import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Zap, ArrowRight } from 'lucide-react';

/** Primary CTA: instant guest access. */
export const GuestAccessCard = ({ language, loading, onGuestLogin }) => (
  <Card className="bg-lux-panel/90 border-lux-gold/20 shadow-[0_12px_32px_rgba(0,0,0,0.55)] mb-4">
    <CardContent className="pt-6 pb-5">
      <Button
        data-testid="guest-login-button"
        onClick={onGuestLogin}
        disabled={loading}
        className="w-full bg-[var(--lux-gold)] text-[var(--lux-ink)] hover:bg-[var(--lux-gold-2)] font-bold h-12 text-base active:scale-[0.98] transition-[background-color,transform] duration-200"
      >
        {loading ? (
          <div className="w-5 h-5 border-2 border-[var(--lux-ink)] border-t-transparent rounded-full animate-spin" />
        ) : (
          <span className="flex items-center gap-2">
            <Zap className="w-5 h-5" />
            {language === 'fr' ? 'Commencer sans inscription' : 'Start without sign up'}
            <ArrowRight className="w-5 h-5" />
          </span>
        )}
      </Button>
      <p className="text-white/30 text-xs text-center mt-3">
        {language === 'fr' ? 'Acc\u00e8s imm\u00e9diat \u00e0 toutes les fonctionnalit\u00e9s' : 'Instant access to all features'}
      </p>
    </CardContent>
  </Card>
);
